import { FlatTree, isLast } from '../../flatTree';

export const navigate = (panels: FlatTree[], tree: FlatTree[], item: FlatTree): FlatTree[] => {
  if (isLast(tree, item.id)) {
    return panels;
  }

  // toggle same layer
  const indexOfItem = panels.indexOf(item);
  if (indexOfItem !== -1) {
    return [...panels].slice(0, indexOfItem);
  }

  const lastItem = panels[panels.length - 1];
  // reduce to lower level
  if (lastItem.level > item.level) {
    const copy = [...panels].slice(0, item.level);
    copy.push(item);
    return copy;
  }

  // switch between different layer on same level
  if (lastItem.level === item.level) {
    const copy = [...panels];
    copy.splice(panels.length - 1, 1, item);
    return copy;
  }

  return [...panels].concat([item]);
};
